import React from 'react';
import { AppProgressBar as ProgressBar } from 'next-nprogress-bar';

const RouteProgressbar = () => {
  return (
    <ProgressBar height="2px" color="#3175AF" options={{ showSpinner: false, easing: 'ease-in' }} />
  );
};

export default RouteProgressbar;
